import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';

const sections = [
  {
    icon: 'ri-focus-3-line',
    title: '网站定位',
    text: '「善良的小姨子在线」是一个专注热门电视剧的在线观看与剧情介绍平台。我们不生产内容，而是把散落在各处的新剧信息整理得清楚好用，让观众快速决定下饭剧、追更剧。',
  },
  {
    icon: 'ri-bar-chart-box-line',
    title: '内容范围',
    text: '覆盖都市、古装、悬疑、爱情、科幻、家庭、犯罪、年代、武侠、喜剧、战争等类型，涵盖中国大陆、中国香港、中国台湾、韩国、日本、美国、英国等地区剧集，并持续追踪每部剧的集数更新。',
  },
  {
    icon: 'ri-flag-2-line',
    title: '发展目标',
    text: '把「查一部剧」这件事做到极致：更准确的剧情简介、更及时的更新提醒、更好用的筛选与推荐，让追剧不再迷路。',
  },
];

export default function About() {
  return (
    <SiteLayout>
      <title>关于我们 - 善良的小姨子在线</title>
      <meta
        name="description"
        content="了解善良的小姨子在线：一个专注热门电视剧在线观看与剧情介绍的平台，介绍网站定位、内容范围、免责声明与联系方式。"
      />
      <meta name="keywords" content="关于我们,善良的小姨子在线,电视剧平台,免责声明" />

      <section className="bg-secondary-800 text-secondary-50">
        <div className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-20">
          <nav className="flex items-center gap-1 text-sm text-secondary-300" aria-label="面包屑">
            <Link to="/" className="transition-colors hover:text-primary-300">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-secondary-50">关于我们</span>
          </nav>
          <h1 className="mt-4 max-w-2xl font-heading text-3xl font-bold md:text-4xl">
            关于「善良的小姨子在线」
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-secondary-200 md:text-base">
            我们相信，追剧本该是一件轻松的事。于是我们做了这个网站：把热门电视剧的剧情、主演、更新进度整理到一起，让你不用在多个页面之间来回跳转，就能找到想看的那一部。
          </p>
        </div>
      </section>

      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-5 md:grid-cols-3">
          {sections.map((s) => (
            <section key={s.title} className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                <i className={`${s.icon} text-2xl`}></i>
              </span>
              <h2 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{s.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.text}</p>
            </section>
          ))}
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-3">
          <section className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 lg:col-span-2">
            <h2 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-950">
              <i className="ri-shield-check-line text-primary-500"></i>
              版权及免责声明
            </h2>
            <div className="mt-3 space-y-3 text-sm leading-relaxed text-foreground-600">
              <p>
                本站为影视资讯与内容整理平台，所有剧集信息、剧情简介、演职人员资料均来源于公开渠道，仅用于信息展示与交流学习，不提供任何真实视频播放、下载或存储服务。
              </p>
              <p>
                页面中的「播放演示」仅为界面交互效果展示，不含真实视频资源。若相关权利人认为本站内容侵犯其合法权益，请通过下方联系方式与我们沟通，我们将在核实后及时处理。
              </p>
              <p>
                本站不涉及真实账户注册、登录、支付或下载功能，收藏等个性化数据仅保存在你的浏览器本地。
              </p>
            </div>
          </section>

          <section className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
            <h2 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-950">
              <i className="ri-customer-service-2-line text-primary-500"></i>
              联系方式
            </h2>
            <p className="mt-2 text-xs text-foreground-500">以下为演示示例信息</p>
            <ul className="mt-4 space-y-3 text-sm text-foreground-700">
              <li className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className="ri-mail-line"></i>
                </span>
                <span>hello@kind-sister.example</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className="ri-wechat-line"></i>
                </span>
                <span>kind_sister_tv</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className="ri-time-line"></i>
                </span>
                <span>工作日 10:00 - 18:00</span>
              </li>
            </ul>
            <Link
              to="/category"
              className="mt-5 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              <i className="ri-compass-3-line"></i>
              去看看有哪些剧
            </Link>
          </section>
        </div>
      </div>
    </SiteLayout>
  );
}